// File: BodiosYakDown.jsx
import React from 'react';
import image1 from '../assets/yak1.png';
import image2 from '../assets/yak2.png';
import image3 from '../assets/yak3.png';

export default function BodiosYakDown() {
  return (
    <main className="w-full text-center uppercase text-stone-800 font-bold leading-[0.9] px-4">
      <div className="mx-auto max-w-[1200px]">
        <h1 className="sr-only">Bodios Yak Gallery</h1>

        {/* <section className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-5">
          <img
            src={image1}
            alt="Yak 1"
            loading="lazy"
            className="object-contain w-full max-w-[351px]"
          />

          <img
            src={image2}
            alt="Yak 2"
            loading="lazy"
            className="object-contain w-full max-w-[351px]"
          />

          <img
            src={image3}
            alt="Yak 3"
            loading="lazy"
            className="object-contain w-full max-w-[351px]"
          />
        </section> */}

      </div>
    </main>
  );
}

